import React, { useState, useEffect } from 'react';

import TableComponent from "common/TableComponent";
import ErrorPanel from "common/ErrorPanel";
import GroupButton from "components/GroupButton/ButtonContainer";
import { DataTableSkeleton } from 'carbon-components-react';
import callGetApi from "../../requests/GetRequests";
import * as Constants from '../../requests/URLConstants';
import "global.scss";
import i18n from "../../i18n";
require("./TaskDetails.scss");
require("./_assistend-remediation.scss");
var config = require('../../config/appConfig');

const AssistendRemediationTab = (props) => {
    const [incidentUrl, setIncidentUrl] = useState('');
    const TaskName = i18n.t('taskDetails.TaskName');
    const AlertName = i18n.t('taskDetails.AlertName');
    const AssignedGroup = i18n.t('taskDetails.AssignedGroup');
    const Rating = i18n.t('taskDetails.Rating');
    const PartyName = i18n.t('taskDetails.PartyName');
    const AlertTime = i18n.t('taskDetails.AlertTime');
    const Status = i18n.t('taskDetails.Status');

    const [headers, setheaders] = useState([
        {
            key: 'TaskName',
            header: TaskName
        }, {
            key: 'alertName',
            header: AlertName
        }, {
            key: 'status',
            header: Status
        }, {
            key: 'groupId',
            header: AssignedGroup
        }, {
            key: 'rating',
            header: Rating
        }, {
            key: 'partyName',
            header: PartyName
        }, {
            key: 'alertTime',
            header: AlertTime
        }]);
    const [approveModal, setapproveModal] = useState(false);
    const [rows, setrows] = useState([]);
    const [taskStatus, setTaskStatus] = useState('');
    const [approveSuccessModal, setapproveSuccessModal] = useState(false)
    const [tasks, setTasks] = useState([]);
    const [loader, setLoader] = useState(true);
    const [error, setError] = useState();

    useEffect(() => {
        getAllTasks();
    }, []);

    function getAllTasks() {
        let formattedData = [];
        setLoader(true);
        setError(null);
        callGetApi(Constants.GETUSERTASKFORINCIDENT + props.incidentId, {
            withCredentials: true,
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Basic d2JhZG1pbjp3YmFkbWlu',
            },
        }).then(resp => {
            //console.log("states/ResposefromUsertask-->", resp);
            if(resp) {
                if(!resp.error) {
                    formattedData = prepareTaskData(resp)
                    setTasks(formattedData);
                } else {
                    setError(resp.error);
                }
            }
            setLoader(false);
        }).catch((error) => {
            setLoader(false);
            setError(error);
        });
    }

    function getReject() {
        setLoader(true)
        callGetApi(Constants.GETREJECT + new URLSearchParams({
            containerId: tasks[0].containerId,
            taskId: tasks[0].taskId
        }), {
            method: 'GET',
            withCredentials: true,
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Basic d2JhZG1pbjp3YmFkbWlu',
            },
        }).then(response => {
            // this.setState({taskStatus:"Rejected"})
            setTaskStatus("Rejected");
            //  this.getUpdatedTaskStatus();
            getAllTasks();
            // setTaskStatus("");

            //console.log("response is " + response.data);  //task-status
        }).catch(() => {
            setLoader(false);
        });
    };

    function getApprove() {
        setLoader(true)
        callGetApi(Constants.GETAPPROVE + new URLSearchParams({
            containerId: tasks[0].containerId,
            taskId: tasks[0].taskId
        }), {
            method: 'GET',
            withCredentials: true,
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Basic d2JhZG1pbjp3YmFkbWlu',
            },
        }).then(response => {
            //console.log("response is " + response.data);  //task-status
            // this.setState({taskStatus:"Completed"})
            //  this.getUpdatedTaskStatus();
            setapproveSuccessModal(true)
            getAllTasks();
            // console.log("response is " + response.data["active-user-tasks"]["task-summary"][0]["task-id"]);
        }).catch(() => {
            setLoader(false);
        });
    };

    function prepareTaskData(resp) {
        let rowsArray = [];
        let taskobject = {};
        if (resp.length) {
            for (let i = 0; i < resp.length; i++) {
                taskobject = {};
                taskobject.id = "taskId" + resp[i]["task-id"] + i;
                taskobject.TaskName = resp[i]["task-input-data"]["TaskName"]
                taskobject.alertName = resp[i]["task-input-data"]["entries"]["alertName"]
                taskobject.status = resp[i]["task-status"];
                taskobject.groupId = resp[i]["task-input-data"]["GroupId"];
                taskobject.rating = resp[i]["task-input-data"]["entries"]["rating"]
                taskobject.partyName = resp[i]["task-input-data"]["entries"]["partyName"]
                taskobject.alertTime = new Date(resp[i]["task-input-data"]["entries"]["alertTime"]).toISOString();
                taskobject.incident_id = resp[i]["task-input-data"]["entries"]["incident_id"];
                taskobject.updated_on = resp[i]["task-input-data"]["entries"]["lastUpdateTime"];
                taskobject.lockedEntries = resp[i]["task-input-data"]["entries"]["lockedEntries"];
                taskobject.incidentUrl = resp[i]["task-input-data"]["entries"]["incident_url"];
                taskobject.taskId = resp[i]["task-id"]
                taskobject.containerId = resp[i]["task-container-id"]
                rowsArray.push(taskobject);
            }
        }
        return rowsArray;
    }

    function getApproveModal() {
        setapproveModal(true);
    }

    function closeShowApproveSuccess() {
        setapproveSuccessModal(!approveSuccessModal)
    }

    function getClaim() {
        setLoader(true)
        let rowsArray = [];
        callGetApi(Constants.GETCLAIM + new URLSearchParams({
            containerId: tasks[0].containerId,
            taskId: tasks[0].taskId
        }), {
            method: 'GET',
            withCredentials: true,
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Basic d2JhZG1pbjp3YmFkbWlu',
            },
        }).then(response => {
            // this.setState({rows: rowsArray});
            //console.log("states/claimed-->" + response);
            //  this.getUpdatedTaskStatus();
            getAllTasks();
            // this.setState({ users: response.data["active-user-tasks"]["task-summary"][0]["task-actual-owner"] });
        }).catch(() => {
            setLoader(false);
        });

    }

    let user = JSON.parse(localStorage.getItem('user'));
    const RemediationTask = i18n.t('manageAutomation.RemediationTask');
    const noActiveTask = i18n.t('manageAutomation.noActiveTask');
    const please = i18n.t('manageAutomation.please');
    const completedTask = i18n.t('manageAutomation.completedTask');
    const inbox = i18n.t('manageAutomation.inbox');
    const Goto = i18n.t('manageAutomation.Goto');
    const SignUp = i18n.t('manageAutomation.SignUp');
    let sysId = incidentUrl ? incidentUrl.substr(incidentUrl.indexOf("=") + 1) : "";
    //console.log("sysId is " + sysId);
    let alertType = 'alert';
    let path = '/IncidentDetails/' + alertType + "/";
    path = path + sysId;
    //console.log("path is" + path);
    let inboxUrl = `${config.serverUrl}` + "/" + "taskDetails";
    //console.log("inbox url is "+inboxUrl);
    if (user !== null && user.access_token !== null) {
        return (
            <>
                <div className="App">
                    <div className="task-content assistend-remediation">
                        <div>
                            <div className="message-table">
                                <div className="incident-details">
                                    <div className="incident-assisted">{RemediationTask}</div>
                                    <div className="claim-button">
                                        {!loader
                                            ?
                                            <GroupButton status = {tasks.length ? tasks[0].status : ''} getApproveModal={getApproveModal} approveSuccessModal={approveSuccessModal} closeShowApproveSuccess={closeShowApproveSuccess}
                                                getApprove={(e) => { getApprove(e) }}
                                                getReject={(e) => { getReject(e) }}
                                                getClaim={(e) => getClaim(e)}
                                            />
                                            :
                                            ''
                                        }
                                    </div>
                                </div>

                                <hr className="line-message " />
                                <div className="table-padding-message">
                                {loader ?
                                    <DataTableSkeleton
                                        columnCount={6}
                                        rowCount={3}
                                    />
                                    :
                                    error ?
                                    <ErrorPanel error={error} size={'sm'} />
                                    :
                                    tasks.length ? <TableComponent rows={tasks}
                                    lockedEntries={true} isExpanded={true} headers={headers} />
                                        :
                                        <h5>
                                            {noActiveTask}
                                            <h5>{Goto}<a href={inboxUrl}>{inbox}</a>{completedTask}</h5>
                                        </h5>
                                }
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </>
        )
    } else {
        return (
            <div>
                <h2>{please}<a href={`https://development.aocc-staging-lon02-b3c-7dced0308bf9da27b6e714d1d05f7137-0000.eu-gb.containers.appdomain.cloud/login`}> {SignUp} </a> </h2>
            </div>
        );
    }

}

export default AssistendRemediationTab
